export default __webpack_public_path__ + "fonts/menu-dots-icon.svg";